var _path, _path2, _g, _path3, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGatherlyLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "0.454 1.288 2320.486 579.245",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2423 585",
    height: 585,
    width: 2423,
    "data-type": "ugc",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    height: 585,
    width: 2423,
    y: 0,
    x: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    id: "3858624a-ce30-4883-bb3e-c29ff163f120_comp-maztatcu_r_comp-ltn4m6o0",
    fill: "none"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2422.05 0H0v585h2422.05z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#3858624a-ce30-4883-bb3e-c29ff163f120_comp-maztatcu_r_comp-ltn4m6o0)"
  }, /*#__PURE__*/React.createElement("mask", {
    height: 453,
    width: 1829,
    y: 0,
    x: 594,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    id: "782ee29a-bfd0-4921-b1b9-518e926b9f48_comp-maztatcu_r_comp-ltn4m6o0",
    fill: "none"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2422.05 0H594v453h1828.05z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#782ee29a-bfd0-4921-b1b9-518e926b9f48_comp-maztatcu_r_comp-ltn4m6o0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#08a5de80-85a0-4a56-84f6-1ffd239b3755_comp-maztatcu_r_comp-ltn4m6o0)",
    d: "M874.56 104.705V325.9c0 42.771-10.53 74.37-31.6 94.798-20.74 20.747-52.18 31.121-94.31 31.121-23.31 0-45.49-3.511-66.555-10.533q-31.12-10.054-50.75-28.248l17.236-25.854q18.193 16.279 44.049 25.375c17.55 6.065 35.91 9.097 55.06 9.097q47.88 0 70.38-22.503 22.5-22.024 22.5-68.944v-32.078c-10.53 15.959-24.42 28.088-41.65 36.387-16.92 8.299-35.75 12.448-56.5 12.448-23.62 0-45.16-5.107-64.634-15.32q-28.726-15.801-45.484-43.569-16.278-28.248-16.278-63.678t16.278-63.199q16.758-27.769 45.484-43.09c19.154-10.214 40.694-15.321 64.634-15.321q32.085 0 57.93 12.927c17.24 8.618 31.12 21.067 41.66 37.345v-48.356zM745.77 316.803c18.2 0 34.63-3.83 49.32-11.49q22.02-11.97 33.99-33.036 12.45-21.066 12.45-47.878 0-26.811-12.45-47.399-11.97-21.066-33.99-32.557c-14.37-7.979-30.8-11.969-49.32-11.969-18.19 0-34.63 3.83-49.31 11.49q-21.547 11.491-33.995 32.557-11.969 21.066-11.969 47.878t11.969 47.878q12.448 21.066 33.995 33.036c14.68 7.66 31.12 11.49 49.31 11.49m273.65-214.014c32.87 0 58.09 8.299 75.64 24.897q26.34 24.417 26.34 72.774v156.082h-32.56v-39.26q-11.49 19.63-33.99 30.642c-14.69 7.341-32.24 11.012-52.67 11.012-28.09 0-50.43-6.703-67.03-20.109s-24.89-31.12-24.89-53.144q0-32.079 22.98-51.708c15.64-13.087 40.37-19.63 74.21-19.63h79.95v-15.321c0-21.705-6.06-38.143-18.19-49.314-12.13-11.491-29.84-17.236-53.14-17.236-15.96 0-31.28 2.713-45.97 8.139-14.68 5.107-27.29 12.289-37.82 21.545l-15.32-25.375q19.155-16.279 45.96-24.897c17.88-6.064 36.71-9.097 56.5-9.097m-11.97 229.335c19.15 0 35.59-4.309 49.31-12.927 13.73-8.937 23.94-21.704 30.64-38.302V239.72h-78.99c-43.09 0-64.64 15.002-64.64 45.005 0 14.683 5.59 26.333 16.76 34.951q16.755 12.448 46.92 12.448m300.6 9.097q-9.585 8.618-23.94 13.406c-9.26 2.873-18.99 4.309-29.21 4.309-23.62 0-41.81-6.384-54.58-19.151-12.77-12.768-19.15-30.802-19.15-54.102V133.431h-45.01v-28.726h45.01v-55.06h33.99v55.06h76.61v28.726h-76.61v150.337q0 22.502 11.01 34.472c7.66 7.66 18.52 11.49 32.56 11.49 7.02 0 13.73-1.117 20.11-3.351 6.7-2.234 12.45-5.426 17.24-9.576zm151.89-238.432c31.6 0 56.65 9.257 75.17 27.77 18.83 18.193 28.24 44.845 28.24 79.956v146.027h-33.99V213.866c0-26.173-6.54-46.122-19.63-59.847s-31.76-20.588-56.02-20.588c-27.13 0-48.67 8.139-64.63 24.418q-23.46 23.939-23.46 66.55v132.143h-33.99V1.288h33.99v147.464c9.26-14.682 22.02-26.013 38.3-33.993s34.95-11.97 56.02-11.97m377.62 138.367h-210.67c1.92 26.174 11.97 47.399 30.17 63.678q27.285 23.939 68.94 23.939c15.64 0 30-2.713 43.09-8.139q19.635-8.619 33.99-24.897l19.15 22.024c-11.17 13.406-25.21 23.62-42.13 30.642-16.6 7.022-34.95 10.533-55.06 10.533q-38.775 0-68.94-16.279-29.685-16.757-46.44-45.962c-11.17-19.471-16.76-41.494-16.76-66.072 0-24.577 5.27-46.601 15.8-66.071 10.85-19.47 25.53-34.632 44.05-45.484 18.83-10.852 39.9-16.279 63.2-16.279s44.2 5.427 62.72 16.279q27.765 16.278 43.56 45.484c10.54 19.151 15.8 41.175 15.8 66.071zm-121.61-109.161q-36.39 0-61.29 23.46c-16.28 15.321-25.53 35.43-27.77 60.326h178.59c-2.24-24.896-11.65-45.005-28.25-60.326-16.28-15.64-36.71-23.46-61.28-23.46m185.53 22.024q11.97-25.376 35.43-38.303 23.94-12.927 58.89-12.927v33.036l-8.14-.479c-26.49 0-47.24 8.14-62.24 24.418q-22.5 24.418-22.5 68.465v128.313h-34V104.705h32.56zM2019.05 1.288h33.99v355.254h-33.99zm301.89 103.417-125.92 282q-15.315 35.43-35.43 50.272c-13.4 9.895-29.52 14.842-48.35 14.842-12.13 0-23.46-1.915-34-5.745-10.53-3.831-19.63-9.576-27.29-17.236l15.8-25.376c12.77 12.768 28.09 19.151 45.97 19.151 11.49 0 21.22-3.191 29.2-9.575q12.45-9.576 22.98-32.557l11.02-24.418-112.52-251.358h35.43l94.8 214.013 94.8-214.013z"
  }))), /*#__PURE__*/React.createElement("mask", {
    height: 535,
    width: 523,
    y: 50,
    x: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    },
    id: "4f4ffa62-ca68-4024-a8f9-56a7af5cc76d_comp-maztatcu_r_comp-ltn4m6o0",
    fill: "none"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M522.558 50H0v535h522.558z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#4f4ffa62-ca68-4024-a8f9-56a7af5cc76d_comp-maztatcu_r_comp-ltn4m6o0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#16772353-e5f3-4866-8a4a-bbb473f2d525_comp-maztatcu_r_comp-ltn4m6o0)",
    d: "M.454 110.01c0-32.984 26.633-59.682 59.358-59.682h311.241c32.79 0 59.358 26.698 59.358 59.682v35.771l38.298-47.046c4.341-6.027 11.405-9.915 19.44-9.915 13.284 0 24.041 10.822 24.041 24.171v231.924c0 13.349-10.757 24.171-24.041 24.171-8.035 0-15.099-3.888-19.44-9.915l-38.298-47.045v35.77c0 32.919-26.568 59.682-59.358 59.682H249.745c-7.128.065-13.544 3.434-17.756 8.554h-.064L107.312 570.553c-4.407 6.027-11.47 9.98-19.441 9.98-13.284 0-24.106-10.822-24.106-24.236 0-3.434.713-6.674 2.009-9.59L99.795 441.21c1.425-3.111 2.268-6.545 2.268-10.109 0-13.025-10.498-23.523-23.458-23.523H59.812c-32.725 0-59.358-26.763-59.358-59.682zm370.664 28.513c15.617 0 28.318-12.766 28.318-28.513s-12.701-28.512-28.318-28.512c-15.682 0-28.383 12.765-28.383 28.512s12.701 28.513 28.383 28.513",
    clipRule: "evenodd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M399.436 110.006c0 15.746-12.702 28.512-28.319 28.512-15.682 0-28.383-12.766-28.383-28.512s12.701-28.513 28.383-28.513c15.617 0 28.319 12.766 28.319 28.513"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 185.845,
    x2: 592.25,
    y1: 185.845,
    x1: 2320.25,
    id: "08a5de80-85a0-4a56-84f6-1ffd239b3755_comp-maztatcu_r_comp-ltn4m6o0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#01ADEB"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03C8AC",
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientUnits: "userSpaceOnUse",
    y2: 196.208,
    x2: -92.248,
    y1: 50.351,
    x1: 512.206,
    id: "16772353-e5f3-4866-8a4a-bbb473f2d525_comp-maztatcu_r_comp-ltn4m6o0"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03CAA5"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A9F2",
    offset: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatherlyLogo);
export default __webpack_public_path__ + "static/media/gatherly-logo.92263bc2b34e3f239043b36d495bcf50.svg";
export { ForwardRef as ReactComponent };